<template>
  <div class="country-issue">
    <el-tabs v-model="activeTab" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="首页配置" name="1">
        <el-form label-width="80px" ref="issueForm" class="issue-form">
          <el-form-item
            label="作品ID"
            v-for="(item, index) in ids"
            :key="index"
          >
            <div class="input-wrapper">
              <el-input
                v-model="item.worksId"
                placeholder="请输入作品id"
              ></el-input>
              <el-button
                style="margin-left: 20px;"
                icon="el-icon-plus"
                type="primary"
                size="mini"
                @click="addIds(1)"
              ></el-button>
              <el-button
                icon="el-icon-minus"
                v-if="ids.length > 1"
                type="primary"
                size="small"
                @click="addIds(-1, index)"
              ></el-button>
            </div>
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          class="confirmBtn"
          :loading="submitLoading"
          @click="submit"
          >保存</el-button
        >
      </el-tab-pane>
      <el-tab-pane label="共创配置" name="2">
        <el-form label-width="80px" ref="issueForm" class="issue-form">
          <el-form-item
            label="作品ID"
            v-for="(item, index) in ids"
            :key="index"
          >
            <div class="input-wrapper">
              <el-input
                v-model="item.worksId"
                placeholder="请输入作品id"
              ></el-input>
              <el-button
                style="margin-left: 20px;"
                icon="el-icon-plus"
                type="primary"
                size="mini"
                @click="addIds(1)"
              ></el-button>
              <el-button
                icon="el-icon-minus"
                v-if="ids.length > 1"
                type="primary"
                size="small"
                @click="addIds(-1, index)"
              ></el-button>
            </div>
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          class="confirmBtn"
          :loading="submitLoading"
          @click="submit"
          >保存</el-button
        >
      </el-tab-pane>
      <el-tab-pane label="授权详情" name="3"
        ><Editor v-if="activeTab == '3'" :html.sync="html" :key="'third'" />

        <el-button type="primary" :loading="submitLoading" @click="submit1"
          >保存</el-button
        >
      </el-tab-pane>
      <el-tab-pane label="联系我们" name="4"
        ><Editor v-if="activeTab == '4'" :html.sync="html" :key="'fourth'" />

        <el-button type="primary" :loading="submitLoading" @click="submit1"
          >保存</el-button
        >
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getshowConfig, addShowconfig } from "@/api/page";
import Editor from "@/components/editor/index.vue";
export default {
  name: "showSetting",
  data() {
    return {
      ids: [{ worksId: "" }],
      submitLoading: false,
      activeTab: "1",
      html: "",
      detailId: "",
    };
  },
  components: {
    Editor,
  },
  created() {
    this.getShowConfig();
  },
  methods: {
    handleClick(tab) {
      this.html = "";
      this.detailId = "";
      this.ids = [{ worksId: "" }];
      this.activeTab = tab.name;
      this.getShowConfig();
    },

    async getShowConfig() {
      const { data } = await this.$ajax.get(getshowConfig, {
        configType: this.activeTab,
      });
      if (data.code == 200) {
        if (this.activeTab == 1 || this.activeTab == 2)
          this.ids = data.data[0] ? data.data : [{ worksId: "" }];
        if (this.activeTab == 3 || this.activeTab == 4) {
          this.html = data.data[0] ? data.data[0].detailText : "";
          this.detailId = data.data[0] ? data.data[0].id : "";
        }
      } else {
        this.$message.error(data.msg || "获取数据失败");
      }
    },
    submit1() {
      this.html;
      if (!this.html) {
        this.$message.warning("请填写内容");
        return;
      }
      this.$ajax
        .post(addShowconfig, [
          {
            configType: this.activeTab,
            detailText: this.html,
            id: this.detailId,
          },
        ])
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("保存成功");
            this.submitLoading = false;
            this.getShowConfig();
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    submit() {
      let hasEmpty = this.ids.every((item) => item.worksId);
      if (!hasEmpty) {
        this.$message.warning("请补充未填写的作品ID");
        return;
      }
      this.ids.forEach((item, index) => {
        item.sortNum = index + 1;
        item.configType = this.activeTab;
      });
      this.submitLoading = true;
      try {
        this.$ajax
          .post(addShowconfig, this.ids)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success("保存成功");
              this.submitLoading = false;
              this.getShowConfig();
            }
          })
          .finally(() => {
            this.submitLoading = false;
          });
      } catch (error) {
        this.submitLoading = false;
      }
    },
    addIds(type, index) {
      if (type == 1) {
        this.ids.push({ worksId: "", configType: this.activeTab });
      } else {
        this.ids.splice(index, 1);
      }
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
:deep(.el-tabs__content) {
  overflow: visible;
}
.country-issue {
  padding: 20px;
  background: #ffffff;

  .issue-form {
    max-width: 800px;
  }

  .input-wrapper {
    width: 420px;
    display: flex;
  }

  .input-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .check-btn {
    white-space: nowrap;
  }

  .confirmBtn {
    margin-left: 20px;
  }

  :deep(.el-form-item__label) {
    font-weight: normal;
    line-height: 32px;
  }

  :deep(.el-textarea__inner) {
    min-height: 100px !important;
  }
}
</style>
